import { Container } from 'react-bootstrap';
import '../skeletons/skeletons.scss';
import './ProductDetailPage.scss';

export function ProductMediaSkeleton() {
  return (
    <article className="carousel-wrapper pt-2 pb-3 product-sm-top-article">
      <div
        className="carousel-skeleton surface-1 glow compact product-detail-skeleton__media"
        aria-hidden="true"
      >
        <div className="ui-skel-rect main">
          <span className="ui-skel-arrow left" />
          <span className="ui-skel-arrow right" />
          <div className="ui-skel-caption">
            <div className="ui-skel-line short" />
            <div className="ui-skel-line" />
          </div>
        </div>

        <div className="thumb-row product-detail-skeleton__thumb-row">
          {Array.from({ length: 4 }).map((_, index) => (
            <span key={index} className="ui-skel-thumb" />
          ))}
        </div>
      </div>
    </article>
  );
}

export function ProductBuyBoxSkeleton() {
  return (
    <aside className="buybox-wrapper d-flex justify-content-center pt-2 pb-3">
      <div className="cart-card-wrapper w-100 d-flex justify-content-center">
        <section
          className="buybox surface-1 product-detail-skeleton__buybox"
          aria-hidden="true"
        >
          <div className="ui-skel-header">
            <div className="ui-skel-badge product-detail-skeleton__eyebrow-skel" />
          </div>

          <div className="ui-skel-body product-detail-skeleton__stack">
            <div className="ui-skel-line product-detail-skeleton__line--price" />
            <div className="ui-skel-line product-detail-skeleton__line--medium" />
            <div className="ui-skel-line short" />
          </div>

          <div className="product-detail-skeleton__buybox-row">
            <div className="ui-skel-line product-detail-skeleton__line--small" />
            <div className="ui-skel-line product-detail-skeleton__line--small" />
          </div>

          <div className="product-detail-skeleton__buybox-row product-detail-skeleton__buybox-row--chips">
            <span className="ui-skel-badge" />
            <span className="ui-skel-badge" />
            <span className="ui-skel-badge" />
          </div>

          <div className="ui-skel-cta product-detail-skeleton__cta" />

          <div className="ui-skel-body product-detail-skeleton__stack product-detail-skeleton__trust-copy">
            <div className="ui-skel-line product-detail-skeleton__line--medium" />
            <div className="ui-skel-line product-detail-skeleton__line--long" />
          </div>
        </section>
      </div>
    </aside>
  );
}

export function ProductDescriptionSkeleton() {
  return (
    <article className="description-article pt-2 pb-3" aria-hidden="true">
      <div className="product-detail-panel product-detail-skeleton__panel surface-1 glow">
        <div className="ui-skel-badge product-detail-skeleton__eyebrow-skel" />

        <div className="ui-skel-body product-detail-skeleton__title-block">
          <div className="ui-skel-line product-detail-skeleton__line--title-xl" />
          <div className="ui-skel-line product-detail-skeleton__line--title-lg" />
        </div>

        <div className="product-detail-skeleton__taxonomy" aria-hidden="true">
          <span className="ui-skel-badge" />
          <span className="ui-skel-badge" />
          <span className="ui-skel-badge" />
        </div>

        <div className="product-detail-panel__stat-grid product-detail-skeleton__stat-grid">
          {Array.from({ length: 3 }).map((_, index) => (
            <div
              key={index}
              className="product-detail-panel__summary-card product-detail-skeleton__metric-card"
            >
              <div className="ui-skel-line short" />
              <div className="ui-skel-line product-detail-skeleton__line--medium" />
            </div>
          ))}
        </div>

        <div className="product-detail-panel__summary-card product-detail-skeleton__copy-card">
          <div className="ui-skel-body product-detail-skeleton__stack">
            <div className="ui-skel-line short" />
            <div className="ui-skel-line" />
            <div className="ui-skel-line" />
            <div className="ui-skel-line product-detail-skeleton__line--long" />
            <div className="ui-skel-line short" />
          </div>
        </div>
      </div>
    </article>
  );
}

export function ProductSpecsSkeleton() {
  return (
    <section
      className="app-section product-specs product-detail-skeleton__section glow pt-2 pb-3"
      aria-hidden="true"
    >
      <div className="product-specs__summary-column">
        <div className="product-specs__grid">
          <div className="app-panel surface-1 glow product-specs__summary-card product-detail-skeleton__spec-card product-detail-skeleton__spec-card--summary">
            <div className="product-detail-skeleton__spec-card-header">
              <span className="ui-skel-line product-detail-skeleton__line--medium" />
              <span className="ui-skel-badge" />
            </div>

            <div className="product-detail-skeleton__spec-list">
              {Array.from({ length: 12 }).map((_, index) => (
                <div key={index} className="product-detail-skeleton__spec-row">
                  <span className="ui-skel-line product-detail-skeleton__spec-key" />
                  <span className="ui-skel-line product-detail-skeleton__spec-value" />
                </div>
              ))}
            </div>

            <div className="product-detail-skeleton__spec-footer">
              <span className="ui-skel-line product-detail-skeleton__line--small" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function ProductReviewsSkeleton() {
  return (
    <section
      className="product-detail-skeleton__section pt-2 pb-3"
      aria-hidden="true"
    >
      <div className="product-detail-skeleton__section-header">
        <span className="ui-skel-badge product-detail-skeleton__eyebrow-skel" />
      </div>

      <div className="product-detail-skeleton__reviews">
        <div className="product-detail-panel__summary-card product-detail-skeleton__review-hero">
          <div className="ui-skel-line product-detail-skeleton__line--title-lg" />
          <div className="ui-skel-line product-detail-skeleton__line--long" />
        </div>

        {Array.from({ length: 3 }).map((_, index) => (
          <div
            key={index}
            className="product-review-skeleton product-detail-panel__summary-card"
          >
            <div className="product-review-skeleton__header">
              <span className="product-review-skeleton__avatar" />
              <div className="product-review-skeleton__lines">
                <span className="product-review-skeleton__line is-short" />
                <span className="product-review-skeleton__line" />
              </div>
            </div>
            <span className="product-review-skeleton__line" />
            <span className="product-review-skeleton__line" />
            <span className="product-review-skeleton__line is-short" />
          </div>
        ))}
      </div>
    </section>
  );
}

function RelatedProductCardSkeleton({ index }) {
  return (
    <div key={index} className="product-card-skeleton surface-1 glow">
      <div className="product-detail-skeleton__related-ribbon">
        <span className="ui-skel-badge" />
        <span className="ui-skel-line product-detail-skeleton__line--quarter" />
      </div>
      <div className="ui-skel-line ui-skel-line--media" />
      <div className="product-card-skeleton__meta">
        <div className="ui-skel-line short" />
        <div className="ui-skel-line" />
        <div className="ui-skel-line product-detail-skeleton__line--half" />

        <div className="product-card-skeleton__row">
          <div className="ui-skel-line product-detail-skeleton__line--half" />
          <div className="ui-skel-line short product-detail-skeleton__line--quarter" />
        </div>

        <div className="product-card-skeleton__row">
          <div className="ui-skel-line short product-detail-skeleton__line--third" />
          <div className="ui-skel-line product-detail-skeleton__line--medium" />
        </div>

        <div className="product-card-skeleton__cta">
          <span className="ui-skel-cta" />
        </div>
      </div>
    </div>
  );
}

export function ProductRelatedSkeleton() {
  return (
    <section
      className="app-section product-related-section product-detail-skeleton__section glow"
      aria-hidden="true"
    >
      <div className="app-section__header product-detail-skeleton__section-header">
        <span className="ui-skel-badge product-detail-skeleton__eyebrow-skel" />
      </div>

      <div className="product-related-carousel__shell product-detail-skeleton__related-shell surface-1 glow">
        <div className="product-detail-skeleton__related-toprail">
          <span className="product-detail-skeleton__related-nav" />
          <span className="ui-skel-line product-detail-skeleton__related-label" />
          <span className="product-detail-skeleton__related-nav" />
        </div>

        <div className="product-detail-skeleton__related-stage">
          <div className="product-detail-skeleton__related-viewport">
            <div
              className="product-related-carousel__edge product-related-carousel__edge--left"
              aria-hidden="true"
            />
            <div
              className="product-related-carousel__edge product-related-carousel__edge--right"
              aria-hidden="true"
            />

            <div className="product-detail-skeleton__related-grid">
              {Array.from({ length: 3 }).map((_, index) => (
                <div
                  key={index}
                  className={`product-detail-skeleton__related-card-slot ${
                    index === 1
                      ? 'product-detail-skeleton__related-card-slot--active'
                      : 'product-detail-skeleton__related-card-slot--side'
                  }`}
                >
                  <RelatedProductCardSkeleton index={index} />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div
          className="product-detail-skeleton__related-pagination"
          aria-hidden="true"
        >
          {Array.from({ length: 4 }).map((_, index) => (
            <span
              key={index}
              className="product-detail-skeleton__related-dot"
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default function ProductDetailSkeleton() {
  return (
    <Container
      fluid="xl"
      className="product-screen-container pt-3 pb-5 product-detail-skeleton"
      aria-busy="true"
      aria-label="Loading product"
    >
      <div className="product-screen-layout">
        <section className="product-screen-layout__media">
          <ProductMediaSkeleton />
        </section>

        <section className="product-screen-layout__buybox">
          <ProductBuyBoxSkeleton />
        </section>

        <section className="product-screen-layout__details">
          <section className="product-screen-layout__description">
            <ProductDescriptionSkeleton />
          </section>

          <section className="product-screen-layout__specs">
            <ProductSpecsSkeleton />
          </section>
        </section>

        <section className="product-screen-layout__reviews">
          <ProductReviewsSkeleton />
        </section>

        <section className="product-screen-layout__related">
          <ProductRelatedSkeleton />
        </section>
      </div>
    </Container>
  );
}
